import { Address } from '@src/main/modules/messages/domain/address/address.interface';
import { Subject } from '@src/main/modules/messages/domain/subject/subject.interface';

export interface SubjectEntity {
  addresses: Address[];
  description: string;
  subjectId?: string;
  visibleOnApp: boolean;
}

export function toSubject(entity: SubjectEntity): Subject {
  return {
    ...entity,
  };
}

export function fromSubject(model: Subject): SubjectEntity {
  return {
    ...model,
  };
}
